// Roles listed here render only the destinations named, in the order named.
// A role that is absent renders the whole menu in source order, which is what
// every role did before EC-1083.
export const APPROVED_NAV = {
  'Environmental Specialist': [
    'dashboard',
    'facility_list',
    'calendar',
    'work_order_summary',
    'ecabinet'
  ]
};

export const getApprovedNav = user => {
  const roles = user?.roles;
  if (!Array.isArray(roles) || !roles.length) {
    return null;
  }

  const navs = roles.map(role => APPROVED_NAV[role]);

  if (navs.some(nav => !nav)) {
    return null;
  }

  return navs.reduce(
    (merged, nav) => merged.concat(nav.filter(navKey => !merged.includes(navKey))),
    []
  );
};
